// @ts-nocheck
import { ButtonPrimary, ButtonText } from "components/Button";
import { AutoColumn } from "components/Column";
import Dropdown from "components/Dropdown";
import { SwapPoolTabs } from "components/NavigationTabs";
import PositionList from "components/PositionList";
import { RowBetween, RowFixed } from "components/Row";
import { darken } from "polished";
import { useContext, useEffect, useState } from "react";
import { Activity } from "react-feather";
import { Link } from "react-router-dom";
import { useWalletModalToggle } from "state/application/hooks";
import styled, { ThemeContext } from "styled-components/macro";
import { ThemedText } from "theme";
import { UnsupportedChainIdError, useWeb3React } from "packages/core";

import { gql, useQuery } from "@apollo/client";

import { ButtonSecondary } from "../../components/Button";
import { AMMS_PER_NETWORK } from "../../constants/amm";
import useInterval from "../../lib/hooks/useInterval";
import { LoadingRows } from "./styleds";
import { ALL_SUPPORTED_CHAIN_IDS } from "constants/chains";

require('./style.css');


const PageWrapper = styled(AutoColumn)`
  max-width: 870px;

  ${({ theme }) => theme.mediaWidth.upToMedium`
    max-width: 800px;
  `};

  ${({ theme }) => theme.mediaWidth.upToSmall`
    max-width: 500px;
    width:100%;
  `};
`
const TitleRow = styled(RowBetween)`
  color: ${({ theme }) => theme.text2};
  flex-wrap: wrap;
  gap: 12px;
  ${({ theme }) => theme.mediaWidth.upToSmall`
    width: 100%;
  `};
  width:512px;
`
const ButtonRow = styled(RowFixed)`
  & > *:not(:last-child) {
    margin-left: 0px;
  }
  width: 100%;
  flex-direction: row;
  justify-content: space-between;
`

const NoLiquidity = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin: auto;  
  width:416px;
  ${({ theme }) => theme.mediaWidth.upToSmall`
  width: 300px;
`};
`
const ResponsiveButtonPrimary = styled(ButtonPrimary)`
  border-radius: 100px;
  padding: 8px 8px;
  width: 184px;
  height:40px;
  border: none;
  font-size:16px;
  font-weight:600;
  ${({ theme }) => theme.mediaWidth.upToSmall`
        width: 48%;
  `};
`

const MainContentWrapper = styled.main`
  background-color: ${({ theme }) => theme.bg0};

  display: flex;
  flex-direction: column;
`
const Web3StatusGeneric = styled(ButtonSecondary)`
  ${({ theme }) => theme.flexRowNoWrap}
  width: 100%;
  align-items: center;
  padding: 0.5rem;
  border-radius: 100px;
  cursor: pointer;
  user-select: none;
  height: 36px;
  margin-right: 0px;
  margin-left: 0px;
  :focus {
    outline: none;
  }
`

const Web3StatusError = styled(Web3StatusGeneric)`
  background-color: ${({ theme }) => theme.red1};
  color: ${({ theme }) => theme.white};
  font-weight: 600;
  border: none;
  margin-top: 2em;
  height: 40px;
  :hover,
  :focus {
    background-color: ${({ theme }) => darken(0.1, theme.red1)};
  }
`

const NetworkIcon = styled(Activity)`
  margin-left: 0.25rem;
  margin-right: 0.5rem;
  width: 16px;
  height: 16px;
`

const Text = styled.p`
  flex: 1 1 auto;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  margin: 0 0.5rem 0 0.25rem;
  font-size: 1rem;
  width: fit-content;
  font-weight: 600;
`

function PositionsLoadingPlaceholder() {
  return (
    <LoadingRows>
      <div />
      <div />
      <div />
      <div />
      <div />
      <div />
      <div />
      <div />
      <div />
      <div />
      <div />
      <div />
    </LoadingRows>
  )
}

const LIQUIDITY_QUERY = gql`
  query GetLiquidities($account: String, $amm: String) {
  exist: liquidities(
    where: {owner: $account, ammType: $amm, lpAmount_not:0}
    orderBy: asset
    orderDirection: asc
  ) {
    id
    asset
    capital
    lpAmount
    ammType
    owner
    capitalAmount
    assetAmount
    bundle
    fee
  },
  nonExist: liquidities(
    where: {owner: $account, ammType: $amm, lpAmount:0}
    orderBy: asset
    orderDirection: asc
  ) {
    id
    asset
    capital
    lpAmount
    ammType
    owner
    capitalAmount
    assetAmount
    bundle
    fee
  }
}
`

const LIQUIDITY_QUERY_HIDE = gql`
  query GetLiquiditiesHide($account: String, $amm: String) {
    liquidities(where: {lpAmount_gt: 0,owner: $account, ammType: $amm}) {
      id
      asset
      capital
      lpAmount
      ammType
      owner
      capitalAmount
      assetAmount
      bundle
      fee
    }
  }
`

export default function Pool() {
  const { account, chainId, error } = useWeb3React()
  const toggleWalletModal = useWalletModalToggle()
  const theme = useContext(ThemeContext)
  const [userHideClosedPositions, setUserHideClosedPositions] = useState(false);
  const showConnectAWallet = Boolean(!account)
  const [textContent, setContent] = useState('Ubeswap')
  const [liquidityQuery, setLiquidityQuery] = useState(LIQUIDITY_QUERY)
  const [data, setData] = useState(null)
  const { loading, data: queryData, refetch } = useQuery(liquidityQuery, {
    pollInterval: 1000,
    variables: { account, amm: textContent, hide: false },
  });

  useInterval(() => refetch({ account: account?.toLowerCase(), amm: textContent }), 1000)

  useEffect(() => {
    (async () => {
      setLiquidityQuery(userHideClosedPositions ? LIQUIDITY_QUERY_HIDE : LIQUIDITY_QUERY)
      await refetch({ account: account?.toLowerCase(), amm: textContent })
    })()
  }, [userHideClosedPositions, textContent, account, refetch])

  useEffect(() => {
    if (userHideClosedPositions) {
      if (queryData && queryData.liquidities) {
        const liquidities = JSON.parse(JSON.stringify(queryData.liquidities))
        liquidities.sort((a, b) => a.capital > b.capital ? -1 : 1)
        setData({ liquidities })
      }
    } else {
      if (queryData && queryData.exist && queryData.nonExist) {
        const exist = JSON.parse(JSON.stringify(queryData.exist))
        const nonExist = JSON.parse(JSON.stringify(queryData.nonExist))
        exist.sort((a, b) => a.capital > b.capital ? -1 : 1)
        nonExist.sort((a, b) => (a.capital > b.capital ? -1 : 1))
        setData({ liquidities: exist.concat(nonExist) })
      }
    }
  }, [queryData, userHideClosedPositions])

  useEffect(() => {
    const pool = window.localStorage.getItem('SELECT_POOL') || 'Ubeswap'
    if(AMMS_PER_NETWORK[chainId] !== undefined && !AMMS_PER_NETWORK[chainId].includes(pool)) {
      window.localStorage.setItem('SELECT_POOL', AMMS_PER_NETWORK[chainId][0])
      setContent(AMMS_PER_NETWORK[chainId][0]);
    } else {
      setContent(pool);
    }
  }, [setContent, chainId])

  const onChangeContent = (value) => {
    setContent(value)
    window.localStorage.setItem('SELECT_POOL', value)
  }
  
  return (
    <>
      <PageWrapper>
        <SwapPoolTabs active={'pool'} />
        <AutoColumn gap="lg" justify="center">
          <AutoColumn gap="lg" style={{ width: '100%', justifyContent: "center" }}>
            <TitleRow style={{ marginBottom: '1rem', justifyContent: 'center' }} padding={'0'}>
                <ButtonRow>  
                  <Dropdown  onUserClick={onChangeContent} items={AMMS_PER_NETWORK[(chainId && ALL_SUPPORTED_CHAIN_IDS.includes(chainId) ? chainId : 44787)]} textContent={textContent}/>
                  <ResponsiveButtonPrimary className = "gradientButton" id="join-pool-button" as={Link} to="/add" style={{ background: "linear-gradient(73.6deg, #85FFC4 2.11%, #5CC6FF 42.39%, #BC85FF 85.72%)" }}>
                    New Position
                  </ResponsiveButtonPrimary>
                </ButtonRow>
            </TitleRow>

            <div style={{background:  "linear-gradient(73.6deg, #85FFC4 2.11%, #5CC6FF 42.39%, #BC85FF 85.72%)", padding:'1px',borderRadius:'40px' }}>
              <MainContentWrapper  style={{ background: "#16161F", minHeight: "586px", padding: '32px',borderRadius:'40px' }} >
                {
                  showConnectAWallet ?
                    <NoLiquidity >
                      <ThemedText.Body color={theme.text3} textAlign="center">
                        <svg width="75" height="75" viewBox="0 0 75 75" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ display:"flex" }}>
                          <path d="M68.75 37.5H50L43.75 46.875H31.25L25 37.5H6.25" stroke="url(#paint0_linear_3832_13200)" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                          <path d="M17.0313 15.9688L6.25 37.5V56.25C6.25 57.9076 6.90848 59.4973 8.08058 60.6694C9.25269 61.8415 10.8424 62.5 12.5 62.5H62.5C64.1576 62.5 65.7473 61.8415 66.9194 60.6694C68.0915 59.4973 68.75 57.9076 68.75 56.25V37.5L57.9688 15.9688C57.4513 14.9275 56.6537 14.0512 55.6655 13.4384C54.6773 12.8256 53.5378 12.5006 52.375 12.5H22.625C21.4622 12.5006 20.3227 12.8256 19.3345 13.4384C18.3463 14.0512 17.5487 14.9275 17.0313 15.9688V15.9688Z" stroke="url(#paint1_linear_3832_13200)" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                          <defs>
                            <linearGradient id="paint0_linear_3832_13200" x1="7.95454" y1="46.875" x2="24.2825" y2="14.8373" gradientUnits="userSpaceOnUse">
                              <stop stopColor="#85FFC4" />
                              <stop offset="0.411458" stopColor="#5CC6FF" />
                              <stop offset="0.854167" stopColor="#BC85FF" />
                            </linearGradient>
                            <linearGradient id="paint1_linear_3832_13200" x1="7.95454" y1="62.5" x2="77.7043" y2="36.8389" gradientUnits="userSpaceOnUse">
                              <stop stopColor="#85FFC4" />
                              <stop offset="0.411458" stopColor="#5CC6FF" />
                              <stop offset="0.854167" stopColor="#BC85FF" />
                            </linearGradient>
                          </defs>
                        </svg>

                      </ThemedText.Body>
                      <ButtonText
                        style={{ marginTop: '.5rem', color: "white", fontSize: "14px" }}
                        onClick={() => setUserHideClosedPositions(!userHideClosedPositions)}
                      >
                        Your positions will appear here
                      </ButtonText>
                      {
                        error instanceof UnsupportedChainIdError ?
                          <Web3StatusError onClick={toggleWalletModal}>
                            <NetworkIcon />
                            <Text>{error instanceof UnsupportedChainIdError ? <>Wrong Network</> : Error}</Text>
                          </Web3StatusError>
                          : showConnectAWallet && (

                          <ButtonPrimary style={{ marginTop: '2em', padding: '8px 16px', width: "100%", height: "40px" }} className="pool-body-connect" onClick={toggleWalletModal}>
                            Connect Wallet
                          </ButtonPrimary>
                        )
                      }
                    </NoLiquidity>
                    :
                  loading ? (
                  <PositionsLoadingPlaceholder />
                ) : ((data && data.liquidities && data.liquidities.length > 0) ? (
                  <PositionList
                    positions={data.liquidities}
                    setUserHideClosedPositions={setUserHideClosedPositions}
                    userHideClosedPositions={userHideClosedPositions}
                  />

                ) : (
                    <NoLiquidity >
                      <ThemedText.Body color={theme.text3} textAlign="center">
                        <svg width="75" height="75" viewBox="0 0 75 75" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ display:"flex" }}>
                          <path d="M68.75 37.5H50L43.75 46.875H31.25L25 37.5H6.25" stroke="url(#paint0_linear_3832_13200)" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                          <path d="M17.0313 15.9688L6.25 37.5V56.25C6.25 57.9076 6.90848 59.4973 8.08058 60.6694C9.25269 61.8415 10.8424 62.5 12.5 62.5H62.5C64.1576 62.5 65.7473 61.8415 66.9194 60.6694C68.0915 59.4973 68.75 57.9076 68.75 56.25V37.5L57.9688 15.9688C57.4513 14.9275 56.6537 14.0512 55.6655 13.4384C54.6773 12.8256 53.5378 12.5006 52.375 12.5H22.625C21.4622 12.5006 20.3227 12.8256 19.3345 13.4384C18.3463 14.0512 17.5487 14.9275 17.0313 15.9688V15.9688Z" stroke="url(#paint1_linear_3832_13200)" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                          <defs>
                            <linearGradient id="paint0_linear_3832_13200" x1="7.95454" y1="46.875" x2="24.2825" y2="14.8373" gradientUnits="userSpaceOnUse">
                              <stop stopColor="#85FFC4" />
                              <stop offset="0.411458" stopColor="#5CC6FF" />
                              <stop offset="0.854167" stopColor="#BC85FF" />
                            </linearGradient>
                            <linearGradient id="paint1_linear_3832_13200" x1="7.95454" y1="62.5" x2="77.7043" y2="36.8389" gradientUnits="userSpaceOnUse">
                              <stop stopColor="#85FFC4" />
                              <stop offset="0.411458" stopColor="#5CC6FF" />
                              <stop offset="0.854167" stopColor="#BC85FF" />
                            </linearGradient>
                          </defs>
                        </svg>

                      </ThemedText.Body>
                      <ButtonText
                        style={{ marginTop: '.5rem', color: "white", fontSize: "14px" }}
                        onClick={() => setUserHideClosedPositions(!userHideClosedPositions)}
                      >
                        Your positions will appear here
                      </ButtonText>
                    </NoLiquidity>
                  ))}
              </MainContentWrapper>
            </div>
          </AutoColumn>
        </AutoColumn>
      </PageWrapper>
    </>
  )
}
